import React from 'react';

const TextSection = ({ description }: { description?: string }) => (
  <div className="h-101 overflow-y-auto rounded-xl border border-gray-200 p-3 text-sm text-gray-700 whitespace-pre-line">
    {description}
  </div>
);

export default TextSection;
